document.addEventListener('DOMContentLoaded',()=>{
  document.querySelectorAll('[data-pbh-site-shell]').forEach((shell)=>{
    const toggle=shell.querySelector('[data-pbh-menu-toggle]');
    const menu=shell.querySelector('[data-pbh-mobile-menu]');
    if(!toggle||!menu)return;
    const close=()=>{toggle.setAttribute('aria-expanded','false');menu.hidden=true};
    toggle.addEventListener('click',()=>{
      const open=toggle.getAttribute('aria-expanded')==='true';
      toggle.setAttribute('aria-expanded',open?'false':'true');
      menu.hidden=open;
    });
    window.addEventListener('resize',()=>{if(window.innerWidth>900)close()});
    menu.querySelectorAll('a').forEach((a)=>a.addEventListener('click',close));
  });
});
